module.exports = __webpack_public_path__ + "img/hiking.7dc697a3.png";